export const environment = {
  production: false,
  // Backend API base URL (development)
  apiUrl: 'https://dev-intranet-backend.arcadia-viajes.com',
  apiBaseUrl: 'https://dev-intranet-backend.arcadia-viajes.com',
  // Public API key for third-party services (placeholder)
  apikey: 'apikey123',
  // Frontend base used for redirects while developing locally
  frontendBaseUrl: 'https://dev-web.arcadia-viajes.com/',
  // Google Maps API key for development (leave empty if not set)
  googleMapsApiKey: '',
  // Scalapay public config used by the payments widget
  scalapay: {
    environment: 'sandbox',
    merchantToken: '8KDS3SPEL' 
  },

   // Valores hardcodeados para probar el método de pago Revolut
  revolut: {
    publicKey: 'pk_Frk7LNDqsWQhNV8QOYxh6bXGFvQ3zjx8bUx5wu6wNtE6Ni1l',
    mode: 'prod' as const, // sandbox para pruebas
  },
  
  devPriceOverride: 0.50,
};
